import { isArray } from "class-validator";

export function valueOrArrayToArray<T>(value: T | Array<T>): Array<T> {
    if (isArray(value)) {
        return value as Array<T>;
    }

    return [value as T];
}
